import ORB1Previewer from 'components/app/marpol/orb1/ORB1Previewer';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { TORB1BackendRecord } from 'redux/app/orb1/@types';
import ORB1AttachmentsPrintView from './ORB1AttachmentsPrintView';
import ORB1RecordParticipantsView from './ParticipantsView';
import { IStore } from 'redux/store';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    orb1Records: TORB1BackendRecord[];
    isPrintVisible: boolean;
    showShipInfo?: boolean;
	vesselId: string;
};
type ORB1PrintProps = OwnProps & PropsFromRedux;
function ORB1Print(props: ORB1PrintProps) {
    const {
        isPrintVisible,
        orb1Records,
        showShipInfo = false,
        vesselName,
        imoNumber,
    } = props;
    if (!isPrintVisible) return null;
    return (
        <div className="p-4">
            {/* <div className="mb-8">
                <h1 className="text-xl font-bold font-redhat-display">
                    Oil Record Book (Part 1)
                </h1>
                <h1 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
                    Machinery Space Operations
                </h1>
                <div className="flex flex-col">
                    <div className="flex flex-row justify-start">
                        <div className="w-24 font-medium text-gray-700">
                            Vessel Name:
                        </div>
                        <div className="flex-1 font-bold uppercase">
                            {props.vesselName}
                        </div>
                    </div>
                    <div className="flex flex-row justify-start">
                        <div className="w-24 font-medium text-gray-700">
                            IMO Number:
                        </div>
                        <div className="flex-1 font-bold uppercase">
                            {props.imoNumber}
                        </div>
                    </div>
                    <div className="flex flex-row justify-start">
                        <div className="w-24 font-medium text-gray-700">
                            Wayship ver.:
                        </div>
                        <div className="flex-1 font-bold uppercase">1.0.62</div>
                    </div>
                </div>
            </div> */}
            {showShipInfo ? (
                <>
                    <ol className="ml-4 list-alpha" start={9}>
                        <li className="mb-2">
                            <b>
                                Additional operational procedures and general
                                remarks
                            </b>
                        </li>
                    </ol>
                    <div className="flex flex-col ">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 text-sm min-w-fit">
                                Name of ship
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                {vesselName}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 text-sm min-w-fit">
                                IMO Number
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                {imoNumber}
                            </p>
                        </div>
                    </div>
                </>
            ) : null}
            <h3 className="my-4 text-lg font-medium">
                Machinery space operations
            </h3>
            <div className="w-full bg-gray-100">
                <table className="w-full wayship-table-light orb1-table">
                    <thead>
                        <tr className="theader">
                            <th>
                                <div className="m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600  border-gray-300 whitespace-nowrap min-w-[100px]">
                                    Date
                                </div>
                            </th>
                            <th>
                                <div className="m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                    <p>Code</p>
                                    <p className="m-0">(Letter)</p>
                                </div>
                            </th>
                            <th>
                                <div className="m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                    <p>Item</p>
                                    <p className="m-0">(number)</p>
                                </div>
                            </th>
                            <th>
                                <div className="m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
                                    Record of operations/signature of officer in
                                    charge
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {orb1Records.map((orbRecord, index) => {
                            const isSubmitterChiefOrMaster =
                                orbRecord.approvedBy
                                    ? orbRecord.approvedBy.staffId ===
                                      orbRecord.submittedBy?.staffId
                                    : false;
                            return (
                                <React.Fragment key={orbRecord._id}>
                                    <ORB1Previewer
                                        orbRecord={orbRecord}
                                    />
                                    <ORB1AttachmentsPrintView
                                        orb1Record={orbRecord}
                                    />
                                    <ORB1RecordParticipantsView
                                        orb1Record={orbRecord}
                                        theme="light"
                                    />
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        vesselName: vesselInfo?.vesselName,
        imoNumber: vesselInfo?.imoNumber,
    };
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB1Print);
